export enum CompanySortTypes {
  STATUS = 'status',
  NAME = 'name',
  USER_QTY = 'userQty',
  MAIN_ACCOUNT = 'mainAccount',
}
